import { MyAlgoWalletConnectors } from './myalgo/index.js';
import { PeraWalletConnectors } from './pera/index.js';

const AlgorandWalletConnectors = (props) => [
    ...MyAlgoWalletConnectors(),
    ...PeraWalletConnectors(),
];

export { AlgorandWalletConnectors };
